export const CK_EDITOR_PORTAL_BODY_CLASS = "ck-editor-dialog-open";

export const toElement = (target: EventTarget | null): Element | null =>
  (target instanceof Element ? target : null);

const CK_EDITOR_SELECTORS = [
  ".ck-body-wrapper",
  ".ck-balloon-panel",
  ".ck-toolbar",
  ".ck-button",
  ".ck-dropdown",
  ".ck-tooltip",
  ".ck-color-picker",
  ".ck-link-form",
  ".ck-link-actions",
  ".ck-input",
] as const;

export const isCKEditorElement = (element: Element | null): boolean =>
  !!element && CK_EDITOR_SELECTORS.some((selector) => Boolean(element.closest?.(selector)));
